import React, { FC } from 'react'

import styled from 'styled-components'

import { WrapperGreeting } from 'components/page/ForeignProfile/ForeignProfile.styled'
import {
  GenericMenu,
  StyledIconWrapper,
  StyledLabelGreeting,
} from 'components/presentational/GenericMenuItemIndex/GenericMenuItemIndex.styled'
import { GreetingActiveSvg } from 'components/presentational/svg/GreetingActiveSvg'

export const ForeignProfileGreetingView: FC<{
  greeting: string
}> = ({ greeting }) => {
  return (
    <WrapperGreeting>
      <GenericMenu
        style={{ alignItems: 'flex-end', padding: 0 }}
        data-name="profile-greeting"
      >
        <StyledLabelGreeting>
          <StyledIconWrapper>
            <GreetingActiveSvg />
          </StyledIconWrapper>
          <div>
            <ContentGreetingWrapper>{greeting}</ContentGreetingWrapper>
          </div>
        </StyledLabelGreeting>
      </GenericMenu>
    </WrapperGreeting>
  )
}

export const ContentGreetingWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
`
